import React from 'react';
import SelectParametro from '../../selectores/SelectParametro.js';
import * as Funciones from '../../funciones/FuncionesParametros.js';

const CampoComboParametro = (props) => {
  const nombre = props.nombre;
  const tipoParametro = props.tipoParametro;
  const parametroActual = props.parametroActual;
  const editar = props.editar;
  const valor = props.valor;
  const estilo = props.estilo;
  const campoDescripcion = props.campoDescripcion;
  const codigoPorDefecto = props.codigoPorDefecto;

  const onChange = (parametro) => {
    props.onChange(nombre, parametro);
  };

  let campo = '';
  if (editar) {
    campo = (
      <SelectParametro
        estilo={estilo}
        tipoParametro={tipoParametro}
        tipoObjeto={parametroActual ? parametroActual.codigo : undefined}
        valor={valor}
        codigoPorDefecto={codigoPorDefecto}
        allowedCodigos={props.allowedCodigos}
        campoDescripcion={campoDescripcion}
        onChange={onChange}
      />
    );
  } else {
    campo = valor ? Funciones.ValorComboParametro(tipoParametro, valor, campoDescripcion) : '';
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoComboParametro;
